// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__OQyuf","modal":"Modal_modal__Yih5X","slide-down":"Modal_slide-down__GctmN"};